/**
 * 中国主要城市经纬度数据库
 * 用于手动选择位置时获取对应的经纬度
 */

export const CITY_COORDINATES = {
  // 直辖市
  '北京市': { latitude: 39.9042, longitude: 116.4074 },
  '上海市': { latitude: 31.2304, longitude: 121.4737 },
  '天津市': { latitude: 39.3434, longitude: 117.3616 },
  '重庆市': { latitude: 29.4316, longitude: 106.9123 },
  
  // 省会城市
  '石家庄市': { latitude: 38.0428, longitude: 114.5149 },
  '太原市': { latitude: 37.8706, longitude: 112.5489 },
  '呼和浩特市': { latitude: 40.8151, longitude: 111.6708 },
  '沈阳市': { latitude: 41.8057, longitude: 123.4328 },
  '长春市': { latitude: 43.8171, longitude: 125.3235 },
  '哈尔滨市': { latitude: 45.8038, longitude: 126.5340 },
  '南京市': { latitude: 32.0603, longitude: 118.7969 },
  '杭州市': { latitude: 30.2741, longitude: 120.1551 },
  '合肥市': { latitude: 31.8206, longitude: 117.2272 },
  '福州市': { latitude: 26.0745, longitude: 119.2965 },
  '南昌市': { latitude: 28.6829, longitude: 115.8579 },
  '济南市': { latitude: 36.6512, longitude: 117.1209 },
  '郑州市': { latitude: 34.7466, longitude: 113.6253 },
  '武汉市': { latitude: 30.5928, longitude: 114.3055 },
  '长沙市': { latitude: 28.2282, longitude: 112.9388 },
  '广州市': { latitude: 23.1291, longitude: 113.2644 },
  '南宁市': { latitude: 22.8170, longitude: 108.3665 },
  '海口市': { latitude: 20.0444, longitude: 110.1989 },
  '成都市': { latitude: 30.5728, longitude: 104.0668 },
  '贵阳市': { latitude: 26.6470, longitude: 106.6302 },
  '昆明市': { latitude: 25.0406, longitude: 102.7129 },
  '拉萨市': { latitude: 29.6520, longitude: 91.1721 },
  '西安市': { latitude: 34.2658, longitude: 108.9541 },
  '兰州市': { latitude: 36.0611, longitude: 103.8343 },
  '西宁市': { latitude: 36.6171, longitude: 101.7782 },
  '银川市': { latitude: 38.4872, longitude: 106.2309 },
  '乌鲁木齐市': { latitude: 43.8256, longitude: 87.6168 },
  
  // 其他重要城市
  '深圳市': { latitude: 22.5431, longitude: 114.0579 },
  '珠海市': { latitude: 22.2710, longitude: 113.5767 },
  '汕头市': { latitude: 23.3540, longitude: 116.6819 },
  '佛山市': { latitude: 23.0218, longitude: 113.1219 },
  '韶关市': { latitude: 24.8103, longitude: 113.5972 },
  '湛江市': { latitude: 21.2707, longitude: 110.3577 },
  '肇庆市': { latitude: 23.0515, longitude: 112.4653 },
  '江门市': { latitude: 22.5790, longitude: 113.0815 },
  '茂名市': { latitude: 21.6631, longitude: 110.9253 },
  '惠州市': { latitude: 23.1115, longitude: 114.4152 },
  '梅州市': { latitude: 24.2888, longitude: 116.1174 },
  '汕尾市': { latitude: 22.7864, longitude: 115.3645 },
  '河源市': { latitude: 23.7435, longitude: 114.7005 },
  '阳江市': { latitude: 21.8577, longitude: 111.9826 },
  '清远市': { latitude: 23.6817, longitude: 113.0564 },
  '东莞市': { latitude: 23.0205, longitude: 113.7518 },
  '中山市': { latitude: 22.5177, longitude: 113.3926 },
  '潮州市': { latitude: 23.6567, longitude: 116.6228 },
  '揭阳市': { latitude: 23.5538, longitude: 116.3556 },
  '云浮市': { latitude: 22.9297, longitude: 112.0446 },
  
  '苏州市': { latitude: 31.2989, longitude: 120.5853 },
  '无锡市': { latitude: 31.4912, longitude: 120.3119 },
  '常州市': { latitude: 31.8122, longitude: 119.9742 },
  '徐州市': { latitude: 34.2044, longitude: 117.2844 },
  '南通市': { latitude: 32.0085, longitude: 120.8947 },
  '连云港市': { latitude: 34.5967, longitude: 119.2216 },
  '淮安市': { latitude: 33.5975, longitude: 119.0153 },
  '盐城市': { latitude: 33.3776, longitude: 120.1573 },
  '扬州市': { latitude: 32.3912, longitude: 119.4215 },
  '镇江市': { latitude: 32.1987, longitude: 119.4252 },
  '泰州市': { latitude: 32.4849, longitude: 119.9233 },
  '宿迁市': { latitude: 33.9631, longitude: 118.2752 },
  
  '宁波市': { latitude: 29.8683, longitude: 121.5440 },
  '温州市': { latitude: 27.9938, longitude: 120.6994 },
  '嘉兴市': { latitude: 30.7467, longitude: 120.7505 },
  '湖州市': { latitude: 30.8703, longitude: 120.0933 },
  '绍兴市': { latitude: 30.0303, longitude: 120.5820 },
  '金华市': { latitude: 29.0789, longitude: 119.6478 },
  '衢州市': { latitude: 28.9566, longitude: 118.8590 },
  '舟山市': { latitude: 29.9853, longitude: 122.2072 },
  '台州市': { latitude: 28.6568, longitude: 121.4285 },
  '丽水市': { latitude: 28.4676, longitude: 119.9229 },
  
  '青岛市': { latitude: 36.0671, longitude: 120.3826 },
  '淄博市': { latitude: 36.8131, longitude: 118.0548 },
  '枣庄市': { latitude: 34.8107, longitude: 117.3238 },
  '东营市': { latitude: 37.4339, longitude: 118.6751 },
  '烟台市': { latitude: 37.4638, longitude: 121.4478 },
  '潍坊市': { latitude: 36.7067, longitude: 119.1619 },
  '济宁市': { latitude: 35.4154, longitude: 116.5871 },
  '泰安市': { latitude: 36.2006, longitude: 117.0888 },
  '威海市': { latitude: 37.5128, longitude: 122.1201 },
  '日照市': { latitude: 35.4164, longitude: 119.5269 },
  '临沂市': { latitude: 35.1041, longitude: 118.3564 },
  '德州市': { latitude: 37.4355, longitude: 116.3594 },
  '聊城市': { latitude: 36.4570, longitude: 115.9854 },
  '滨州市': { latitude: 37.3817, longitude: 117.9708 },
  '菏泽市': { latitude: 35.2333, longitude: 115.4806 },
  
  // 陕西省地级市
  '宝鸡市': { latitude: 34.3612, longitude: 107.1467 },
  '咸阳市': { latitude: 34.3297, longitude: 108.7093 },
  '渭南市': { latitude: 34.4994, longitude: 109.5097 },
  '延安市': { latitude: 36.5853, longitude: 109.4897 },
  '汉中市': { latitude: 33.0777, longitude: 107.0233 },
  '榆林市': { latitude: 38.2850, longitude: 109.7341 },
  '安康市': { latitude: 32.6854, longitude: 109.0293 },
  '商洛市': { latitude: 33.8730, longitude: 109.9401 },
  
  // 河北省地级市
  '唐山市': { latitude: 39.6304, longitude: 118.1758 },
  '秦皇岛市': { latitude: 39.9354, longitude: 119.5999 },
  '邯郸市': { latitude: 36.6256, longitude: 114.5391 },
  '邢台市': { latitude: 37.0682, longitude: 114.5045 },
  '保定市': { latitude: 38.8740, longitude: 115.4648 },
  '张家口市': { latitude: 40.8112, longitude: 114.8841 },
  '承德市': { latitude: 40.9543, longitude: 117.9632 },
  '沧州市': { latitude: 38.3037, longitude: 116.8386 },
  '廊坊市': { latitude: 39.5368, longitude: 116.6838 },
  '衡水市': { latitude: 37.7387, longitude: 115.6708 },
  
  // 河南省地级市
  '开封市': { latitude: 34.7971, longitude: 114.3074 },
  '洛阳市': { latitude: 34.6197, longitude: 112.4540 },
  '平顶山市': { latitude: 33.7352, longitude: 113.1929 },
  '安阳市': { latitude: 36.0960, longitude: 114.3929 },
  '鹤壁市': { latitude: 35.7480, longitude: 114.2972 },
  '新乡市': { latitude: 35.3030, longitude: 113.9268 },
  '焦作市': { latitude: 35.2159, longitude: 113.2421 },
  '濮阳市': { latitude: 35.7617, longitude: 115.0290 },
  '许昌市': { latitude: 34.0359, longitude: 113.8526 },
  '漯河市': { latitude: 33.5811, longitude: 114.0165 },
  '三门峡市': { latitude: 34.7730, longitude: 111.2001 },
  '南阳市': { latitude: 33.0041, longitude: 112.5288 },
  '商丘市': { latitude: 34.4143, longitude: 115.6564 },
  '信阳市': { latitude: 32.1285, longitude: 114.0921 },
  '周口市': { latitude: 33.6250, longitude: 114.6965 },
  '驻马店市': { latitude: 32.9803, longitude: 114.0220 },
  
  // 湖北省地级市
  '黄石市': { latitude: 30.2000, longitude: 115.0385 },
  '十堰市': { latitude: 32.6293, longitude: 110.7982 },
  '宜昌市': { latitude: 30.6919, longitude: 111.2861 },
  '襄阳市': { latitude: 32.0091, longitude: 112.1226 },
  '鄂州市': { latitude: 30.3969, longitude: 114.8947 },
  '荆门市': { latitude: 31.0354, longitude: 112.1997 },
  '孝感市': { latitude: 30.9244, longitude: 113.9169 },
  '荆州市': { latitude: 30.3350, longitude: 112.2410 },
  '黄冈市': { latitude: 30.4539, longitude: 114.8722 },
  '咸宁市': { latitude: 29.8418, longitude: 114.3222 },
  '随州市': { latitude: 31.6898, longitude: 113.3826 },
  
  // 湖南省地级市
  '株洲市': { latitude: 27.8274, longitude: 113.1342 },
  '湘潭市': { latitude: 27.8296, longitude: 112.9443 },
  '衡阳市': { latitude: 26.8968, longitude: 112.5719 },
  '邵阳市': { latitude: 27.2389, longitude: 111.4677 },
  '岳阳市': { latitude: 29.3570, longitude: 113.1288 },
  '常德市': { latitude: 29.0397, longitude: 111.6987 },
  '张家界市': { latitude: 29.1167, longitude: 110.4791 },
  '益阳市': { latitude: 28.5537, longitude: 112.3550 },
  '郴州市': { latitude: 25.7706, longitude: 113.0145 },
  '永州市': { latitude: 26.4204, longitude: 111.6132 },
  '怀化市': { latitude: 27.5500, longitude: 109.9599 },
  '娄底市': { latitude: 27.6999, longitude: 111.9937 },
  
  // 四川省地级市
  '自贡市': { latitude: 29.3393, longitude: 104.7787 },
  '攀枝花市': { latitude: 26.5820, longitude: 101.7160 },
  '泸州市': { latitude: 28.8719, longitude: 105.4425 },
  '德阳市': { latitude: 31.1270, longitude: 104.3979 },
  '绵阳市': { latitude: 31.4675, longitude: 104.6793 },
  '广元市': { latitude: 32.4353, longitude: 105.8434 },
  '遂宁市': { latitude: 30.5328, longitude: 105.5928 },
  '内江市': { latitude: 29.5801, longitude: 105.0584 },
  '乐山市': { latitude: 29.5522, longitude: 103.7657 },
  '南充市': { latitude: 30.7991, longitude: 106.0824 },
  '眉山市': { latitude: 30.0577, longitude: 103.8487 },
  '宜宾市': { latitude: 28.7518, longitude: 104.6308 },
  '广安市': { latitude: 30.4564, longitude: 106.6333 },
  '达州市': { latitude: 31.2090, longitude: 107.4682 },
  '雅安市': { latitude: 29.9800, longitude: 103.0135 },
  '巴中市': { latitude: 31.8691, longitude: 106.7536 },
  '资阳市': { latitude: 30.1282, longitude: 104.6419 },
  
  // 更多省份的地级市可以继续添加...
};

/**
 * 根据城市名称获取经纬度（支持在线查询）
 * @param {string} cityName - 城市名称（如："西安市"）
 * @param {string} provinceName - 省份名称（如："陕西省"，可选）
 * @returns {Promise<object|null>} - { latitude, longitude } 或 null
 */
export async function getCityCoordinates(cityName, provinceName = null) {
  // 1. 先从本地数据库查找
  if (CITY_COORDINATES[cityName]) {
    console.log(`✅ 从本地数据库找到 ${cityName} 的坐标:`, CITY_COORDINATES[cityName]);
    return CITY_COORDINATES[cityName];
  }
  
  // 移除"市"后缀再查找
  const cityWithoutSuffix = cityName.replace('市', '').replace('县', '').replace('区', '');
  for (const [key, value] of Object.entries(CITY_COORDINATES)) {
    if (key.startsWith(cityWithoutSuffix)) {
      console.log(`✅ 从本地数据库找到 ${cityName} (匹配${key}) 的坐标:`, value);
      return value;
    }
  }
  
  // 2. 本地找不到，使用在线地理编码API
  console.log(`⚠️ 本地数据库未找到 ${cityName}，尝试在线查询...`);
  
  try {
    // 使用 Nominatim 地理编码API
    const searchQuery = provinceName ? `${cityName}, ${provinceName}, 中国` : `${cityName}, 中国`;
    const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(searchQuery)}&format=json&limit=1&accept-language=zh-CN`;
    
    const response = await fetch(url, {
      headers: {
        'User-Agent': 'PlantAI2025/1.0'
      }
    });
    
    const data = await response.json();
    
    if (data && data.length > 0) {
      const result = {
        latitude: parseFloat(data[0].lat),
        longitude: parseFloat(data[0].lon)
      };
      console.log(`✅ 在线查询到 ${cityName} 的坐标:`, result);
      return result;
    } else {
      console.warn(`❌ 在线查询 ${cityName} 失败，未找到结果`);
      return null;
    }
  } catch (error) {
    console.error(`❌ 在线查询 ${cityName} 失败:`, error);
    return null;
  }
}

/**
 * 根据省份名称获取省会城市经纬度
 * @param {string} provinceName - 省份名称（如："陕西省"）
 * @returns {Promise<object|null>} - { latitude, longitude } 或 null
 */
export async function getProvinceCapitalCoordinates(provinceName) {
  const provinceCapitalMap = {
    '北京市': '北京市',
    '天津市': '天津市',
    '上海市': '上海市',
    '重庆市': '重庆市',
    '河北省': '石家庄市',
    '山西省': '太原市',
    '内蒙古自治区': '呼和浩特市',
    '辽宁省': '沈阳市',
    '吉林省': '长春市',
    '黑龙江省': '哈尔滨市',
    '江苏省': '南京市',
    '浙江省': '杭州市',
    '安徽省': '合肥市',
    '福建省': '福州市',
    '江西省': '南昌市',
    '山东省': '济南市',
    '河南省': '郑州市',
    '湖北省': '武汉市',
    '湖南省': '长沙市',
    '广东省': '广州市',
    '广西壮族自治区': '南宁市',
    '海南省': '海口市',
    '四川省': '成都市',
    '贵州省': '贵阳市',
    '云南省': '昆明市',
    '西藏自治区': '拉萨市',
    '陕西省': '西安市',
    '甘肃省': '兰州市',
    '青海省': '西宁市',
    '宁夏回族自治区': '银川市',
    '新疆维吾尔自治区': '乌鲁木齐市',
  };
  
  const capitalCity = provinceCapitalMap[provinceName];
  if (capitalCity) {
    return getCityCoordinates(capitalCity);
  }
  
  console.warn(`未找到省份 "${provinceName}" 的省会城市`);
  return null;
}

